import qs from "qs";
import envConfig from "@/helpers/envConfig.ts";
import { FetchError, FetchErrorType } from "./error";

const API_PREFIX = envConfig.VUE_APP_API_URL + "/api";

const qsOpts = {
  skipNulls: true,
  addQueryPrefix: true,
};

export type Methods = "GET" | "POST" | "PUT" | "DELETE";
export type RequestRawParams = {
  body?: BodyInit | undefined | null | object;
  query?: Record<
    string,
    (string | number | null | boolean) | (string | number | null | boolean)[]
  >;
  signal?: AbortSignal;
  headers?: Record<string, string> | Headers;
};

export const addNewHeader = (
  headers: Headers,
  name: string,
  value: string | undefined | null
) => {
  if (value && !headers.has(name)) {
    headers.set(name, value);
  }
};

export const requestRaw = async (
  method: Methods,
  url: string,
  { body, query, signal, headers }: RequestRawParams = {}
) => {
  const prefix = url.startsWith("/") ? API_PREFIX : "";
  const queryStr = query ? qs.stringify(query, qsOpts) : "";
  const sendHeaders =
    headers instanceof Headers ? headers : new Headers(headers);
  let fixedBody;
  if (body) {
    if (
      body instanceof FormData ||
      typeof body === "string" ||
      body instanceof Blob ||
      body instanceof ArrayBuffer ||
      ArrayBuffer.isView(body) ||
      body instanceof URLSearchParams ||
      ("ReadableStream" in window && body instanceof window.ReadableStream)
    ) {
      fixedBody = body;
    } else {
      fixedBody = JSON.stringify(body);
      addNewHeader(sendHeaders, "Content-Type", "application/json");
    }
  }

  let res;
  try {
    res = await fetch(prefix + url + queryStr, {
      method,
      headers: sendHeaders,
      body: fixedBody,
      signal,
    });
  } catch (e) {
    if (
      typeof e === "object" &&
      e != null &&
      "name" in e &&
      e.name === "AbortError"
    ) {
      throw new FetchError(FetchErrorType.Aborted);
    }
    throw new FetchError(FetchErrorType.NetworkError, undefined, e);
  }
  return res;
};
